import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type DataProps = {
	text: string,
	val: string
}

interface uiOverlayState {
	form: string,
	id: string,
	type: string,
	data?: DataProps[],
	onchange?: Function
}
interface uiState {
	connections: number,
	visible: boolean,
	overlay: uiOverlayState,
	datepicker: datepickerState,
	menuLeft: number,
	menuClientRight: number,
	infoVisible: boolean,
	infoMessage: string,
	errorVisible: boolean,
	errorMessage: string,
	wishlistPopupVisible: boolean,
	wishlistPopupCaseno: string,
	wishlistPopupCasetype: string,
	wishlistEditPopupVisible: boolean,
	changePasswordPopupVisible: boolean,
	newPassword: string,
	confirmPassword: string,
	passError: string,
	isChangingPass: boolean,
	isEmailSent: boolean,
}
export interface infoState {
	visible: boolean,
	message: string
}
export interface wishlistState {
	visible: boolean,
	caseno: string,
	casetype: string
}
export interface dayState {
	date: number,
	day: number,
	month: number,
	timestamp: number,
	dayString: string
}
interface datepickerState {
	index: number,
	numberOfDays: number,
	firstDay: number,
	year: number,
	month: number,
	monthDetails: dayState[],
	selectedDay: number
}

const initialState: uiState = {
	connections: 0,
	visible: false,
	overlay: {
		form: '',
		id: '',
		type: ''
	},
	datepicker: {
		index: 0,
		numberOfDays: 0,
		firstDay: 0,
		year: 0,
		month: 0,
		monthDetails: [],
		selectedDay: 0
	},
	menuLeft: 0,
	menuClientRight: 0,
	infoVisible: false,
	infoMessage: '',
	errorVisible: false,
	errorMessage: '',
	wishlistPopupVisible: false,
	wishlistPopupCaseno: '',
	wishlistPopupCasetype: '',
	wishlistEditPopupVisible: false,
	changePasswordPopupVisible: false,
	newPassword: '',
	confirmPassword: '',
	passError: '',
	isChangingPass: false,
	isEmailSent: false,
}

export const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		setOverlay: (state: { overlay: any; visible: boolean; }, action: PayloadAction<uiOverlayState>) => {
			state.overlay = action.payload;
			state.visible = (action.payload.id !== '' ? true : false);
		},
		setDPState: (state: { datepicker: any; }, action: PayloadAction<datepickerState>) => {
			state.datepicker = action.payload;
		},
		IncConns: (state) => {
			state.connections++;
		},
		DecConns: (state) => {
			state.connections--;
		},
		toggleMenu: (state) => {
			if (state.menuLeft === 460) {
				state.menuLeft = 0;
			} else {
				state.menuLeft = 460;
			}
		},
		openMenu: (state) => {
			state.menuLeft = 415;
		},
		closeMenu: (state) => {
			state.menuLeft = 0;
		},
		toggleSlider: (state) => {
			if (state.menuClientRight === -560) {
				state.menuClientRight = 0;
			} else {
				state.menuClientRight = -560;
			}
		},
		setInfo: (state: uiState, action: PayloadAction<infoState>) => {
			state.infoVisible = action.payload.visible;
			state.infoMessage = action.payload.message;
		},
		setError: (state: uiState, action: PayloadAction<infoState>) => {
			state.errorVisible = action.payload.visible;
			state.errorMessage = action.payload.message;
		},
		setWishlistPopup: (state, action: PayloadAction<wishlistState>) => {
			state.wishlistPopupVisible = action.payload.visible;
			state.wishlistPopupCaseno = action.payload.caseno;
			state.wishlistPopupCasetype = action.payload.casetype;
		},
		setWishlistEditPopup: (state, action: PayloadAction<wishlistState>) => {
			state.wishlistEditPopupVisible = action.payload.visible;
			state.wishlistPopupCaseno = action.payload.caseno;
			state.wishlistPopupCasetype = action.payload.casetype;
		},
		setNewPassword: (state, action: PayloadAction<string>) => {
			state.newPassword = action.payload;
		},
		setConfirmPassword: (state, action: PayloadAction<string>) => {
			state.confirmPassword = action.payload;
		},
		setChangePasswordPopup: (state, action: PayloadAction<boolean>) => {
			state.changePasswordPopupVisible = action.payload;
		},
		setPassError: (state, action: PayloadAction<string>) => {
			state.passError = action.payload;
		},
		setChangingPass: (state, action: PayloadAction<boolean>) => {
			state.isChangingPass = action.payload;
		},
		setEmailSent: (state, action: PayloadAction<boolean>) => {
			state.isEmailSent = action.payload;
		}
	}
})

export const { setOverlay, setDPState, IncConns, DecConns, toggleMenu, openMenu, closeMenu,
	toggleSlider, setInfo, setError, setWishlistPopup, setWishlistEditPopup, setNewPassword, setConfirmPassword, setChangePasswordPopup, setPassError, setChangingPass, setEmailSent } = uiSlice.actions;
export default uiSlice.reducer;